import { TIME } from './Words/TIME';
import { HOME } from './Words/HOME';
import { PERSON } from './Words/PERSON';
import { YOU } from './Words/YOU';
import { HELLO } from './Words/HELLO';
import { THANK_YOU } from './Words/THANK_YOU';
import { PLEASE } from './Words/PLEASE';

var wordList = ['TIME', 'HOME', 'PERSON', 'YOU','HELLO','THANK_YOU','PLEASE'];

export {
    TIME, HOME, PERSON, YOU,HELLO,THANK_YOU,PLEASE, wordList
}